export function currency(str) {
		 if(str.toString().indexOf(".") > -1){
		 return specificFormatTwo(str);
	 }
	 str = Number(str).toFixed(4).toString(); //类型转换
	var temp = str;
	var pos = str.indexOf(".");
	if(parseInt(temp.substring(pos+1)) == 0){
		str = str.substring(0,pos);
		pos = -1;
	}
	if(pos > -1){
		str = str.substring(0,pos);
		var decimal = temp.substring(pos+1);
		if(parseInt(decimal.substring(3)) == 0){
			if(parseInt(decimal.substring(2)) == 0){
				if(parseInt(decimal.substring(1)) == 0){
					decimal = decimal.substring(0, 1);
				}
				decimal = decimal.substring(0, 2);
			}
			decimal = decimal.substring(0, 3);
		}
	}
	if(str.length > 3){
		var mod = str.length % 3;
		var output = (mod > 0 ? (str.substring(0, mod)) : '');
		for(var i = 0; i < Math.floor(str.length / 3); i++){
			if((mod == 0) && (i == 0))
				output += str.substring(mod + 3 * i, mod + 3 * i + 3);
			else
				output += ',' + str.substring(mod + 3 * i, mod + 3 * i + 3);
		}
		if(pos > -1) {
			return (output +"."+ decimal);
		} else {
			return (output);
		}
		return output;
	} else {
		if(pos > -1) {
			return str + "."+ decimal;
		} else {
			return str;
		}
		return str;
	}
}
export function addCommaSpecific(str) {
			str = parseFloat(str).toFixed(2);
		str = str.toString(); //类型转换
		var temp = str;
		var pos = str.indexOf(".");
		if(pos > -1){
			str = str.substring(0,pos);
			var decimal = temp.substring(pos+1);
			if(parseInt(decimal.substring(2,3)) > 4 ) {
				decimal = (parseInt(decimal.toString().substring(0,2)) + 1).toString();
			} else {
				decimal = decimal.toString().substring(0,2);
			}
		}
		if(str.length > 3){
			var mod = str.length % 3;
			var output = (mod > 0 ? (str.substring(0, mod)) : '');
			for(i = 0; i < Math.floor(str.length / 3); i++){
				if((mod == 0) && (i == 0))
					output += str.substring(mod + 3 * i, mod + 3 * i + 3);
				else
					output += ',' + str.substring(mod + 3 * i, mod + 3 * i + 3);
			}
			if(pos > -1 && decimal!='00') {
				return (output +"."+ decimal);
			} else {
				return (output);
			}
		} else {
			if(pos > -1 && decimal!='00') {
				return str + "."+ decimal;
			} else {
				return str;
			}
		}
}
export function formatDate (str) {
	var yy = str.slice(0,4);
	var dd =  str.slice(4,6);
	return yy + '-' + dd;
}
export function formatDay (str) {
	var dd = str.slice(6,8);
	return dd;
}
function specificFormatTwo(str) {
		 str = Number(str).toFixed(3).toString(); //类型转换
	var temp = str;
	var pos = str.indexOf(".");
	/*if(parseInt(temp.substring(pos+1)) == 0){
		str = str.substring(0,pos);
		pos = -1;
	}*/
	if(pos > -1){
		str = str.substring(0,pos);
		var decimal = temp.substring(pos+1);
		if(parseInt(decimal.substring(2)) == 0||decimal.substring(2) == ''){
			if(parseInt(decimal.substring(1)) == 0||decimal.substring(1) == ''){
				if(parseInt(decimal.substring(0))==0||decimal.substring(0)==''){
					decimal = '00';
				}else{					
					decimal = decimal.substring(0, 1)+'0';
				}
			}else {				
				decimal = decimal.substring(0, 2);
			}
		}else{
			decimal = decimal.substring(0, 2);
		}
	}
	if(str.length > 3){
		var mod = str.length % 3;
		var output = (mod > 0 ? (str.substring(0, mod)) : '');
		for(var i = 0; i < Math.floor(str.length / 3); i++){
			if((mod == 0) && (i == 0))
				output += str.substring(mod + 3 * i, mod + 3 * i + 3);
			else
				output += ',' + str.substring(mod + 3 * i, mod + 3 * i + 3);
		}
		if(pos > -1) {
			return (output +"."+ decimal);
		} else {
			return (output);
		}
		return output;
	} else {
		if(pos > -1) {
			return str + "."+ decimal;
		} else {
			return str;
		}
		return str;
	}
}


//////////////////
// WEBPACK FOOTER
// ./config/util/filter.js
// module id = 5Jvq
// module chunks = 11